import React from 'react';
import cn from 'clsx';

import Typography from '../../../../library/typography/typography';

import styles from './product-code.scss';

interface ProductCodeProps {
  code?: string;
}

function ProductCode(props: ProductCodeProps) {
  const { code } = props;

  if (!code) {
    return null;
  }

  return (
    <Typography className={cn(styles['code'], 'product-code')} tag="span">
      Item #{code}
    </Typography>
  );
}

export default ProductCode;
